/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckGeneralError } from './PaxCheckGeneralError';
import {
    PaxCheckGeneralErrorFromJSON,
    PaxCheckGeneralErrorFromJSONTyped,
    PaxCheckGeneralErrorToJSON,
    PaxCheckGeneralErrorToJSONTyped,
} from './PaxCheckGeneralError';
import type { PaxCheckApplyDocumentError } from './PaxCheckApplyDocumentError';
import {
    PaxCheckApplyDocumentErrorFromJSON,
    PaxCheckApplyDocumentErrorFromJSONTyped,
    PaxCheckApplyDocumentErrorToJSON,
    PaxCheckApplyDocumentErrorToJSONTyped,
} from './PaxCheckApplyDocumentError';

/**
 * 
 * @export
 * @interface PaxCheckApplyRecognisedDocumentResponseError
 */
export interface PaxCheckApplyRecognisedDocumentResponseError {
    /**
     * 
     * @type {PaxCheckGeneralError}
     * @memberof PaxCheckApplyRecognisedDocumentResponseError
     */
    generalError?: PaxCheckGeneralError;
    /**
     * 
     * @type {PaxCheckApplyDocumentError}
     * @memberof PaxCheckApplyRecognisedDocumentResponseError
     */
    operationError?: PaxCheckApplyDocumentError;
}

/**
 * Check if a given object implements the PaxCheckApplyRecognisedDocumentResponseError interface.
 */
export function instanceOfPaxCheckApplyRecognisedDocumentResponseError(value: object): value is PaxCheckApplyRecognisedDocumentResponseError {
    return true;
}

export function PaxCheckApplyRecognisedDocumentResponseErrorFromJSON(json: any): PaxCheckApplyRecognisedDocumentResponseError {
    return PaxCheckApplyRecognisedDocumentResponseErrorFromJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyRecognisedDocumentResponseError {
    if (json == null) {
        return json;
    }
    return {
        
        'generalError': json['general_error'] == null ? undefined : PaxCheckGeneralErrorFromJSON(json['general_error']),
        'operationError': json['operationError'] == null ? undefined : PaxCheckApplyDocumentErrorFromJSON(json['operationError']),
    };
}

export function PaxCheckApplyRecognisedDocumentResponseErrorToJSON(json: any): PaxCheckApplyRecognisedDocumentResponseError {
    return PaxCheckApplyRecognisedDocumentResponseErrorToJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentResponseErrorToJSONTyped(value?: PaxCheckApplyRecognisedDocumentResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'general_error': PaxCheckGeneralErrorToJSON(value['generalError']),
        'operationError': PaxCheckApplyDocumentErrorToJSON(value['operationError']),
    };
}

